import { render, staticRenderFns } from "./ViewerHelpDialog.vue?vue&type=template&id=28c76312&scoped=true"
import script from "./ViewerHelpDialog.vue?vue&type=script&lang=js"
export * from "./ViewerHelpDialog.vue?vue&type=script&lang=js"
import style0 from "./ViewerHelpDialog.vue?vue&type=style&index=0&id=28c76312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c76312",
  null
  
)

export default component.exports